export default __webpack_public_path__ + "static/media/logo.d8a6e81c.svg";